import { render, staticRenderFns } from "./ProgresoParte.vue?vue&type=template&id=fc635d62&"
import script from "./ProgresoParte.vue?vue&type=script&lang=js&"
export * from "./ProgresoParte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports